import React, { useState, useEffect, createContext } from 'react';
import './app.css';
import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import { Mixpanel } from './Mixpanel';
import _ from 'lodash';
import axios from 'axios';

import Shop from "./pages/shop/shop"
import Loader from './components/loader/loader';
import Navbar from './components/navbar/navbar';
import CartPage from './components/cartPage/cartPage';
import Checkout from './pages/checkout/checkout';
import ThankYou from "./pages/thankYou/thankYou"


import Nexum from './pages/nexum/nexum';
import Product from './pages/product/product';

export const Context = createContext()

const development = false
const host = development?"http://192.168.0.152:3001/":"https://www.myvigilapp.com/"
const mp_url = `${host}mixpanel`
const cartVersion = 1.1
const cartName = `vigil_cart_${cartVersion}`

if (development) {
  ReactPixel.init('1483517825520603', {autoConfig: true, debug: false,}); // Development
  
}
else {
  ReactPixel.init('636581138447653', {autoConfig: true, debug: false,}); // Production
  
}



function App() {

  const [loading, setLoading] = useState(false)
  const [cart, setCart] = useState([])
  const [products, setProducts] = useState([])
  const [totalPrice, setTotalPrice] = useState(0)
  const [discountPrice, setDiscountPrice] = useState(0)
  const [pages, setPages] = useState(["Nexum", "Nexum Mini", "Accessories"])
  const [page, setPage] = useState("Nexum")
  const [expanded, setExpanded] = useState(false)
  const [showcart, setShowCart] = useState(false)
  const [showNav, setShowNav] = useState(true)
  const [showPages, setShowPages] = useState(true)
  const [id, setID] = useState("")
  const [productview, setProductView] = useState(false)
  const [stage, setStage] = useState(0)
  const [mpid, setMpID] = useState(localStorage.getItem("mp_uid")?localStorage.getItem("mp_uid"):"")
  const [filter, setFilter] = useState("All")
  const filters = ["All", "Kids/Family", "Keys/Wallets/Cars", "Pets"]
  const clientID = development?"AThVduMQ-GyVTTb-M82hKh5WLaXhMN6YyEMnPdZgM-a-1UD2IU6meAvH583xUyxghPSs6LMmVtesVCEW":"AbjL9Ly9BFg3vRQ9KF_Rf-VEmllaXoFnR15ctuRr_8twmwwN9GRXsY9jU8Kck4XIB-mi_DxJDOoBS4Sr"

 
  // useEffect(()=>{
  //   if (id) {
  //     setProductView(true)
  //     setStage(1)
  //     console.log("trying")
  //   }
  //   else {
  //     setProductView(false)
  //     setStage(0)
  //   }
  // }, [id])

  useEffect(()=>{
    axios({
      url:host+"products",
      method:"GET"
    }).then((res)=>{
        // console.log(res)
        let sorted = res.data.filter((prod)=>prod.id.includes("BUN"))
        let prods = res.data.filter((prod)=>!prod.id.includes("BUN"))
        setProducts([...prods, ...sorted])
        // console.log([...prods, ...sorted])
    }).catch((e)=>{
        console.log(e)
        alert("Error when connecting to Server. Try again later")
    })
    let temp = localStorage.getItem(cartName)?JSON.parse(localStorage.getItem(cartName)):[]
    setCart(localStorage.getItem(cartName)?JSON.parse(localStorage.getItem(cartName)):[])
    setTotalPrice(Number(temp.reduce((sum, current)=>sum+(current.price*current.quantity),0).toFixed(2)))
    setDiscountPrice(Number(temp.reduce((sum, current)=>sum+(current.discount*current.quantity),0).toFixed(2)))

  },[])

  useEffect(()=>{
    let temp = pages
    temp = temp.filter((el)=>el!==page)
    temp.unshift(page)
    setPages(temp)
    setExpanded(false)
  },[page])

  useEffect(()=>{
    let uid = localStorage.getItem("mp_uid")
    if (!uid) {
      axios({
        url:`${host}uid`,
        method:"GET"
      }).then((res)=>{
        localStorage.setItem("mp_uid", res.data.uid)
        setMpID(res.data.uid)
      })
      .catch((e)=>console.log(e))
    }

  },[])

  function sanitizeNumber(number) {
    let x = 1345.40
    let num = String(number.toLocaleString("en-US"))
    // console.log(number, num)

    if (num.includes(".")) {
      // console.log(num)
      if (num.substring(num.indexOf(".")+1).length < 2) {
        return num+"0"
      }
      else {
        return(num)
      }
      
    } 
    else {
      // console.log("period notincluded", num)
      return num+".00"
    }
  }

  function updateCart(contents) {
    localStorage.setItem(cartName, JSON.stringify(contents))
    setTotalPrice(Number(contents.reduce((sum, current)=>sum+(current.price*current.quantity),0).toFixed(2)))
    setDiscountPrice(Number(contents.reduce((sum, current)=>sum+(current.discount*current.quantity),0).toFixed(2)))
  }



  const addCart = (id, price, discount, name)=>{
    let found = cart.filter((item)=>item.id===id)[0]
    // console.log(found)
    // console.log("why are we seeing undefined", dev, color, attach, "id", id, "idArr", idArr, "bool", idArr[0]==="NEXMIN")
    if (found) {
        setCart(cart.map((item)=>{
            if ((item.id===id)) {
                return(
                    {...item, quantity:item.quantity+1}
                )
            }
            else {
                return(item)
            }
        }).sort((a,b)=>a.name.localeCompare(b.name)))
        updateCart(cart.map((item)=>{
            if ((item.id===id)) {
                return(
                    {...item, quantity:item.quantity+1}
                )
            }
            else {
                return(item)
            }
        }).sort((a,b)=>a.name.localeCompare(b.name)))
    }
    else {
        
        setCart([...cart, {id:id, name:name, quantity:1, price:price, discount:discount}].sort((a,b)=>a.name.localeCompare(b.name)))
        updateCart([...cart, {id:id, name:name, quantity:1, price:price, discount:discount}].sort((a,b)=>a.name.localeCompare(b.name)))
    }
    
    
    
}

const removeCart = (id)=>{
    let target = cart.filter((item)=>item.id===id)[0]
    let rest = cart.filter((item)=>!(item.id===id))
    // console.log("target", target)
    // console.log("rest", rest)
    if (target.quantity > 1) { 
        // console.log("rest", rest)
        // console.log("targets", targets)
        // console.log("sliced", targets.slice(0,targets.length-1))
        // targets.pop()
        target.quantity = target.quantity-1
        // console.log(target)
        rest.push(target)
        // console.log("everthing", rest)
    }
    
    setCart(rest.sort((a,b)=>a.name.localeCompare(b.name)))
    updateCart(rest.sort((a,b)=>a.name.localeCompare(b.name)))
    // localStorage.setItem("cart", JSON.stringify(cart))
    // console.log(rest)
}

  return (
    <div className="App">
      {loading?<Loader/>:""}
      {/* <BrowserRouter> */}
      <HashRouter>
        <Context.Provider value={{
          setLoading:setLoading,
          cart:cart,
          products:products,
          setProducts:setProducts,
          total:totalPrice,
          page:page,
          setPage:setPage,
          pages:pages,
          setPages:setPages,
          expanded:expanded,
          setExpanded:setExpanded,
          addCart:addCart,
          removeCart:removeCart,
          showcart:showcart,
          setShowCart:setShowCart,
          sanitizeNumber:sanitizeNumber,
          showPages:showPages,
          setShowPages:setShowPages,
          setCart:setCart,
          updateCart:updateCart,
          ReactPixel:ReactPixel,
          stage:stage,
          setStage:setStage,
          id:id,
          setID:setID,
          productview:productview,
          url:host,
          mp_url:mp_url,
          mpid:mpid,
          filter:filter,
          setFilter:setFilter,
          filters:filters,
          setShowNav:setShowNav,
          discount:discountPrice,
          setDiscount:setDiscountPrice,
          clientID:clientID
        }}>
          {showcart?<CartPage />:""}
          {showNav?<Navbar />:""}
          <Routes>
            <Route path='/' element={<Shop/>} />
            {/* <Route path='/NEX' element={<Nexum />} />
            <Route path='/NXM' element={<Nexum />} />
            <Route path='/TOT' element={<Nexum />} />
            <Route path='/TOTSLM' element={<Nexum />} />
            <Route path='/PAW' element={<Nexum />} />
            <Route path='/NLSBUN' element={<Nexum />} />
            <Route path='/OEHBUN' element={<Nexum />} /> */}
            {
              products.map((prod)=>{
                return(
                  <Route path={`/${prod.id}`} element={<Product/>} />
                )
              })
            }
            <Route path='/checkout' element={<Checkout />} />
            <Route path='/thankyou' element={<ThankYou />} />
          </Routes>
        </Context.Provider>
      </HashRouter>
      {/* </BrowserRouter>       */}
    </div>
  );
}

export default App;
